import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_2: FaireProductEntity = {
  token: "caden-lane-2",
  type: "product",
  name: "Sweet Like Candy Convertible Zip Romper | Blue",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/4fd8a9d408dfe8f9ad1d492d4f80e86624ecbafc986ca406a531d9a55c418382.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1798,1798,x0,y0,safe&width=720",
  priceDollars: 20,
  msrpDollars: 40,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
